import { useCallback, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'react-bootstrap';
import type { CouponDefType } from 'state/missed-deal-feeedback/feedback/model';

interface Props {
  selectedFrequency: string;

  hasValueChanged: boolean;
  className?: string;
  onFrequencySelected: (frequency: CouponDefType) => void;
}

export function FrequencyDropdown({ selectedFrequency, className, hasValueChanged, onFrequencySelected }: Props) {
  const [dropdownOpen, setOpen] = useState(false);

  const onFrequencyChanged = useCallback(
    (newFrequency: any) => {
      if (newFrequency === selectedFrequency) {
        return;
      }

      onFrequencySelected(newFrequency);
    },
    [onFrequencySelected, selectedFrequency],
  );

  const toggle = () => setOpen(!dropdownOpen);
  return (
    <Dropdown show={dropdownOpen} onToggle={toggle} className={className}>
      <DropdownToggle
        variant={hasValueChanged ? 'outline-info' : 'outline-primary'}
        className="border-0 p-1"
        aria-haspopup="listbox"
      >
        {selectedFrequency}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onFrequencyChanged('PA')} hidden={selectedFrequency === 'PA'}>
          PA
        </DropdownItem>
        <DropdownItem onClick={() => onFrequencyChanged('PP')} hidden={selectedFrequency === 'PP'}>
          PP
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
